<template>
    <div>
        <b-card no-body v-show="mostrarDetalhePropostaPreco">
            <b-card-header>
                <div class="float-left">
                    <span class="h5">
                        Licitação {{ propostaPreco.numeroLicitacao }}
                    </span>

                    <b-badge
                        class="ml-2"
                        variant="warning"
                    >
                        {{ propostaPreco.statusDescricao }}
                    </b-badge>

                    <span class="ml-2 text-primary">
                        <i class="fa fa-refresh fa-lg icon-button" title="Atualizar"
                            @click.stop="obterPropostaPreco()">
                        </i>
                    </span>
                </div>
                <div class="float-right">
                    <b-button variant="danger" @click.stop="voltar">
                        <span>
                            <i class="fa fa-history mr-2"></i> Voltar
                        </span>
                    </b-button>
                </div>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    v-if="erros.length > 0"
                    :erros="erros"
                ></app-erros-box>

                <div ref="areaImpressao">

                <div class="so-imprimir carimbo-geracao mb-1" style="font-size: 10px; color: #555;">
                    Documento gerado em {{ dataHoraImpressao }} por usuário {{ nomeUsuarioImpressao }}
                </div>

                <div class="so-imprimir cabecalho-impressao mb-3">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tr>
                            <td style="width: 25%; vertical-align: middle; text-align: left;">
                                <img
                                    :src="logoSuapeBase64"
                                    alt="Logo SUAPE"
                                    style="max-height: 60px; max-width: 140px; object-fit: contain;"
                                />
                            </td>
                            <td style="width: 50%; vertical-align: middle; text-align: center;">
                                <div style="font-size: 14px; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">
                                    Proposta de Preço
                                </div>
                                <div style="font-size: 12px; margin-top: 4px;">
                                    Licitação {{ propostaPreco.numeroLicitacao }}
                                </div>
                            </td>
                            <td style="width: 25%; vertical-align: middle; text-align: right;">
                                <img
                                    v-if="propostaPreco.fornecedor && propostaPreco.fornecedor.logo"
                                    :src="propostaPreco.fornecedor.logo"
                                    alt="Logo do Fornecedor"
                                    style="max-height: 60px; max-width: 140px; object-fit: contain;"
                                />
                            </td>
                        </tr>
                    </table>
                    <hr style="border: 1px solid #ccc; margin-top: 8px;" />
                </div>

                <b-row>
                    <b-col>
                        <b-alert show variant="info">
                            <div class="mt-2">
                                Licitação: <strong>{{ propostaPreco.numeroLicitacao }} </strong>
                            </div>
                            <div class="mt-2">
                                Objeto: <strong>{{ propostaPreco.objetoContratacao }} </strong>
                            </div>
                            <div class="mt-2">
                                Bancos: <strong>{{ propostaPreco.bancos }} </strong>
                            </div>
                            <div v-if="propostaPreco.fornecedor">
                                <div class="mt-3">
                                    <span class="text-dark font-weight-bold">Dados do Fornecedor</span>
                                </div>
                                <div class="mt-2">
                                    CNPJ (vencedor): <strong>{{ cnpjMask(propostaPreco.fornecedor.cpfCnpj) }} </strong>
                                </div>
                                <div class="mt-2">
                                    Razao Social: <strong>{{ propostaPreco.fornecedor.razaoSocial }} </strong>
                                </div>
                            </div>

                            <vinculo-fornecedor
                                v-if="mostrarFormVinculoFornecedor"
                                :propostaPrecoId="propostaPreco.propostaPrecoId"
                                @fornecedorVinculado="obterPropostaPreco"
                            />

                        </b-alert>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col v-if="ehContratoDeEngenharia" class="col-4">
                        <b-row>
                            <b-col>
                                <b-form-group>
                                    <label :class="['text-dark', 'font-weight-bold', { required: temItemServico }]">BDI Serviço (%)</label>
                                    <money
                                        class="form-control text-right"
                                        ref="bdiGeral"
                                        v-model="propostaPreco.bdiGeral"
                                        v-bind="configuracaoDecimal"
                                        :disabled="!habilitarFormBdiPropostaPreco || !temItemServico"
                                    />
                                    <b-form-invalid-feedback
                                        v-if="!$v.propostaPreco.bdiGeral.required"
                                        :state="$v.propostaPreco.bdiGeral.$error ? false : null"
                                    >
                                        BDI Serviço é obrigatório.
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-else-if="!$v.propostaPreco.bdiGeral.minValue"
                                        :state="$v.propostaPreco.bdiGeral.$error ? false : null"
                                    >
                                        {{ (temItemServico && ehContratoDeEngenharia)
                                            ? 'BDI Serviço deve ser maior que zero.'
                                            : 'BDI Serviço não pode ser negativo.' }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group>
                                    <label :class="['text-dark', 'font-weight-bold', { required: temItemMaterial }]">BDI Material (%)</label>
                                    <money
                                        class="form-control text-right"
                                        ref="bdiDiferenciado"
                                        v-model="propostaPreco.bdiDiferenciado"
                                        v-bind="configuracaoDecimal"
                                        :disabled="!habilitarFormBdiPropostaPreco || !temItemMaterial"
                                    />
                                    <b-form-invalid-feedback
                                        v-if="!$v.propostaPreco.bdiDiferenciado.required"
                                        :state="$v.propostaPreco.bdiDiferenciado.$error ? false : null"
                                    >
                                        BDI Material é obrigatório.
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-else-if="!$v.propostaPreco.bdiDiferenciado.minValue"
                                        :state="$v.propostaPreco.bdiDiferenciado.$error ? false : null"
                                    >
                                        BDI Material não pode ser negativo.
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="d-flex justify-content-end align-items-end mb-2 nao-imprimir">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-button
                                v-if="mostrarBtnAtualizarDataBaseParaReajustamento"
                                variant="secondary"
                                ref="btnAtualizarDataBaseParaReajustamento"
                                class="ml-4"
                                @click.stop="atualizarDataBaseParaReajustamento"
                                style="min-width: 130px;"
                            >
                                <i class="fa fa-calendar mr-2"></i>
                                Atualizar Data Base para Reajustamento
                            </b-button>
                            <b-button
                                v-if="mostrarBtnExportarPlanilha"
                                variant="success"
                                ref="btnExportarPlanilha"
                                class="ml-4"
                                @click.stop="exportar"
                                style="min-width: 130px;"
                            >
                                <i class="fa fa-file-excel-o mr-2"></i>
                                Exportar Planilha
                            </b-button>
                            <b-button
                                v-if="mostrarBtnImprimir && abaAtiva === 0"
                                variant="secondary"
                                class="ml-2"
                                :disabled="btnImprimirDesabilitado"
                                @click.stop="imprimirPropostaPreco"
                            >
                                <i class="fa fa-print"></i>
                                Imprimir
                            </b-button>
                        </div>
                    </b-col>
                </b-row>

                <b-row
                    v-if="ehContratoDeEngenharia && habilitarFormBdiPropostaPreco"
                    class="mt-n2 mb-2"
                >
                    <b-col>
                        <label class="font-italic text-muted">
                            * Informe os valores de BDI para liberar os campos de valor unitário dos itens
                        </label>
                    </b-col>
                </b-row>

                <b-tabs nav-class="nao-imprimir" v-model="abaAtiva">
                    <b-tab
                        title="Itens"
                        active
                    >
                        <b-row>
                            <b-col class="col-2 col-span-10">
                                <b-form-group>
                                    <label class="text-dark font-weight-bold">Total da Proposta de Preço</label>
                                    <money
                                        disabled
                                        class="form-control text-right"
                                        v-model="propostaPreco.total"
                                        v-bind="configuracaoDecimal"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <arvore-itens
                                    v-for="(item, idx) in propostaPreco.itens"
                                    :key="idx"
                                    :exibir-form="exibirFormItensPropostaPreco"
                                    :habilitar-form="habilitarFormItensPropostaPreco"
                                    :bdiGeral="propostaPreco.bdiGeral"
                                    :bdiDiferenciado="propostaPreco.bdiDiferenciado"
                                    :semBDI="!ehContratoDeEngenharia"
                                    :item="item"
                                    @item-alterado="recalcularTudo"
                                    @item-atualizado="agendarAutoSalvar"
                                />
                            </b-col>
                        </b-row>
                    </b-tab>

                    <b-tab title="Histórico">
                        <proposta-preco-historico
                            :historico="propostaPreco.historico"
                            :propostaPrecoId="propostaPreco.propostaPrecoId"
                        />
                    </b-tab>
                </b-tabs>

                <div class="so-imprimir rodape-impressao mt-3">
                    <hr style="border: 1px solid #ccc; margin-bottom: 8px;" />
                    <table style="width: 100%; border-collapse: collapse; font-size: 11px; color: #555;">
                        <tr>
                            <td style="text-align: left;">
                                Proposta: <strong>{{ propostaPreco.propostaPrecoId }}</strong>
                                &nbsp;|&nbsp;
                                Licitação: <strong>{{ propostaPreco.numeroLicitacao }}</strong>
                            </td>
                        </tr>
                    </table>
                </div>

                </div>

                <b-row class="mt-3">
                    <b-col>
                        <b-button
                            variant="warning"
                            class="mr-2"
                            @click.stop="voltar"
                        >
                            Voltar
                        </b-button>
                        <b-button
                            v-if="mostrarBtnHabilitarFornecedor"
                            variant="success"
                            class="mr-2"
                            @click.stop="mostrarModalHabilitarFornecedor = true"
                        >
                            Habilitar Fornecedor
                        </b-button>
                        <b-button
                            v-if="mostrarBtnInabilitarFornecedor"
                            variant="danger"
                            class="mr-2"
                            @click.stop="mostrarModalInabilitarFornecedor = true"
                        >
                            Inabilitar Fornecedor
                        </b-button>
                        <b-button
                            v-if="mostrarBtnSolicitarDiligencia"
                            variant="warning"
                            class="mr-2 btn-solicitar-diligencia"
                            @click.stop="mostrarModalSolicitarDiligenciaFornecedor = true"
                        >
                            Solicitar Diligência
                        </b-button>
                        <b-button
                            v-if="mostrarBtnSalvar"
                            variant="secondary"
                            class="mr-2"
                            @click.stop="confirmarSalvarPropostaPreco"
                        >
                            Salvar
                        </b-button>
                        <b-button
                            v-if="mostrarBtnFinalizar"
                            variant="primary"
                            class="mr-2"
                            @click.stop="confirmarFinalizarPropostaPreco"
                        >
                            Finalizar
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>

        <modal-inabilitar-fornecedor
            :mostrarModal="mostrarModalInabilitarFornecedor"
            @update:mostrarModal="mostrarModalInabilitarFornecedor = $event"
            @fornecedorInabilitado="obterPropostaPreco"
        />

        <modal-habilitar-fornecedor
            :mostrarModal="mostrarModalHabilitarFornecedor"
            @update:mostrarModal="mostrarModalHabilitarFornecedor = $event"
            @fornecedorHabilitado="obterPropostaPreco"
        />

        <modal-solicitar-diligencia-fornecedor
            :mostrarModal="mostrarModalSolicitarDiligenciaFornecedor"
            @update:mostrarModal="mostrarModalSolicitarDiligenciaFornecedor = $event"
            @diligenciaFornecedorSolicitada="obterPropostaPreco"
        />

        <modal-atualizar-data-base-reajustamento
            :mostrarModal="mostrarModalAtualizarDataBaseReajustamento"
            @update:mostrarModal="mostrarModalAtualizarDataBaseReajustamento = $event"
            @dataBaseReajustamentoAtualizada="obterPropostaPreco"
        />
    </div>
</template>
<script>
import PropostaPrecoServico from './PropostaPrecoServico';
import cnpjMask from '@/shared/mask/cnpjMask';
import html2pdf from "html2pdf.js";
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    components: {
        ArvoreItens: () => import('./componentes/ArvoreItens.vue'),
        PropostaPrecoHistorico: () => import('./componentes/PropostaPrecoHistorico.vue'),
        ModalInabilitarFornecedor: () => import('./componentes/ModalInabilitarFornecedor.vue'),
        ModalHabilitarFornecedor: () => import('./componentes/ModalHabilitarFornecedor.vue'),
        ModalSolicitarDiligenciaFornecedor: () => import('./componentes/ModalSolicitarDiligenciaFornecedor.vue'),
        ModalAtualizarDataBaseReajustamento: () => import('./componentes/ModalAtualizarDataBaseReajustamento.vue'),
        VinculoFornecedor: () => import('./componentes/VinculoFornecedor.vue'),
    },
    data() {
        return {
            erros: [],
            propostaPreco: {
                bdiGeral: 0,
                bdiDiferenciado: 0,
            },
            configuracaoDecimal: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            mostrarModalHabilitarFornecedor: false,
            mostrarModalInabilitarFornecedor: false,
            mostrarModalSolicitarDiligenciaFornecedor: false,
            mostrarModalAtualizarDataBaseReajustamento: false,
            timerAutoSalvar: null,
            abaAtiva: 0,
            dataHoraImpressao: '',
            nomeUsuarioImpressao: '',
            logoSuapeBase64: 'data:image/png;base64,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',
        }
    },

    validations() {
        return {
            propostaPreco: {
                bdiGeral: {
                    required,
                    minValue: (this.temItemServico && this.ehContratoDeEngenharia) ? minValue(0.01) : minValue(0)
                },
                bdiDiferenciado: {
                    required,
                    minValue: minValue(0)
                }
            }
        }
    },

    computed: {
        mostrarDetalhePropostaPreco () {
            return this.$route.name === 'PropostasPrecos_Detalhe'
        },

        mostrarFormVinculoFornecedor () {
            const STATUS_AGUARDANDO_PROPONENTE = 1;

            return this.$route.name === 'PropostasPrecos_Detalhe' &&
                this.$temAcessoView('PROP-PRECO-OBTER-01') &&
                this.$temAcessoView('PROP-PRECO-VINC-00') &&
                this.propostaPreco.status == STATUS_AGUARDANDO_PROPONENTE;
        },

        mostrarBtnExportarPlanilha() {
            const PROPOSTA_FINALIZADA = 4;
            const STATUS_FORNECEDOR_HABILITADO = 6;

            return (this.$temAcessoView('PROP-PRECO-EXP-00') || this.$temAcessoView('PROP-PRECO-REG-00'))
                && (this.propostaPreco.status == PROPOSTA_FINALIZADA || this.propostaPreco.status == STATUS_FORNECEDOR_HABILITADO);
        },

        mostrarBtnAtualizarDataBaseParaReajustamento() {
            const STATUS_FORNECEDOR_HABILITADO = 6;

            return this.$temAcessoView('PROP-PRECO-ATU-01') && this.propostaPreco.status == STATUS_FORNECEDOR_HABILITADO;
        },

        habilitarFormBdiPropostaPreco() {
            return this.$temAcessoView('PROP-PRECO-REG-00')
                && this.$store.getters.isFornecedor
                && this.propostaPreco.disponivelPreenchimento;
        },

        exibirFormItensPropostaPreco() {
            return this.habilitarFormBdiPropostaPreco
        },

        temItemServico() {
            return this.temItemDoTipo(1)
        },

        temItemMaterial() {
            return this.temItemDoTipo(2)
        },

        ehContratoDeEngenharia() {
            // registros antigos (tipoContrato null) são OrçaFascio → tratar como com BDI
            if (!this.propostaPreco.tipoContrato) return true
            const TIPOS_COM_BDI = ['Obras', 'Serviços de Engenharia']
            return TIPOS_COM_BDI.includes(this.propostaPreco.tipoContrato)
        },

        habilitarFormItensPropostaPreco() {
            const bdiOk = !this.ehContratoDeEngenharia || (
                (!this.temItemServico || this.propostaPreco.bdiGeral > 0) &&
                (!this.temItemMaterial || this.propostaPreco.bdiDiferenciado >= 0)
            )
            return this.$temAcessoView('PROP-PRECO-REG-00')
                && this.habilitarFormBdiPropostaPreco
                && bdiOk;
        },

        mostrarBtnHabilitarFornecedor() {
            const PROPOSTA_FINALIZADA = 4;

            return this.$temAcessoView('PROP-PRECO-INA-00')
                && this.propostaPreco.status == PROPOSTA_FINALIZADA;
        },

        mostrarBtnSolicitarDiligencia() {
            const PROPOSTA_FINALIZADA = 4;

            return this.$temAcessoView('PROP-PRECO-DIL-00')
                && this.propostaPreco.status == PROPOSTA_FINALIZADA;
        },

        mostrarBtnInabilitarFornecedor() {
            const PROPOSTA_FINALIZADA = 4;

            return this.$temAcessoView('PROP-PRECO-INA-00')
                && this.propostaPreco.status == PROPOSTA_FINALIZADA;
        },

        mostrarBtnSalvar() {
            return this.$temAcessoView('PROP-PRECO-REG-00')
                && this.$store.getters.isFornecedor
                && this.propostaPreco.disponivelPreenchimento;
        },

        mostrarBtnFinalizar() {
            return this.$temAcessoView('PROP-PRECO-REG-00')
                && this.$store.getters.isFornecedor
                && this.propostaPreco.disponivelPreenchimento;
        },

        mostrarBtnImprimir() {
            const PROPOSTA_FINALIZADA = 4;
            const STATUS_FORNECEDOR_HABILITADO = 6;

            return (this.$temAcessoView('PROP-PRECO-REG-00') || this.$temAcessoView('PROP-PRECO-EXP-00'))
                && (this.propostaPreco.status == PROPOSTA_FINALIZADA || this.propostaPreco.status == STATUS_FORNECEDOR_HABILITADO);
        },

    },

    methods: {
        cnpjMask,

        temItemDoTipo(tipo) {
            const buscar = (itens) => itens.some(item =>
                (item.tipo == tipo) || (item.itens && buscar(item.itens))
            )

            return !!(this.propostaPreco.itens && buscar(this.propostaPreco.itens))
        },

        obterPropostaPreco(comLoading = true) {
            if (comLoading) this.$store.dispatch('addRequest');

            PropostaPrecoServico.ObterPorId(this.$route.params.propostaPrecoId)
                .then(response => {
                    this.propostaPreco = response.data;
                    this.erros = [];
                })
                .catch(error => {
                    console.error('Erro ao obter proposta de preço:', error)
                    this.erros = [`Erro ao obter proposta de preço: ${error}`]
                    this.$toast.error(
                        'Erro ao obter proposta de preço!',
                        'Erro',
                        this.$toastConfig.error
                    );
                })
                .finally(() => {
			        this.$store.dispatch('removeRequest')
                })
        },

        voltar() {
            this.$emit('recarregarListaBoletinsMedicao')
            this.$router.push({ name: 'PropostasPrecos' });
        },

        gerarDicionarioValorUnitario(itens) {
            const dict = {};
            itens.forEach(item => {
                if (item.tipo && item.propostaPrecoItemId && item.valorUnitario != null) {
                    dict[item.propostaPrecoItemId] = Number(item.valorUnitario);
                }
                // Se houver subitens recursivos:
                if (item.itens && Array.isArray(item.itens)) {
                    Object.assign(dict, this.gerarDicionarioValorUnitario(item.itens));
                }
            });
            return dict;
        },

        confirmarSalvarPropostaPreco() {
            this.$v.$touch()

            if (this.$v.$invalid){
                this.$toast.warning(
                    'Verifique os campos obrigatórios antes de salvar a proposta de preço.',
                    'Atenção',
                    this.$toastConfig.warning
                );

                return;
            }

            this.salvarPropostaPreco();
        },

        salvarPropostaPreco(comLoading = true, aoSalvarComSucesso = null) {
            const itens = this.gerarDicionarioValorUnitario(this.propostaPreco.itens);

            const dto = {
                bdiGeral: this.propostaPreco.bdiGeral,
                bdiDiferenciado: this.propostaPreco.bdiDiferenciado,
                valoresItens: itens
            }

            if (comLoading) this.$store.dispatch('addRequest')

            PropostaPrecoServico.AtualizarPrecoItens(this.$route.params.propostaPrecoId, dto)
                .then(response => {
                    if (response.data.success) {
                        this.erros = [];
                        if (aoSalvarComSucesso) {
                            aoSalvarComSucesso();
                        } else {
                            this.$toast.success('Proposta de preço salva com sucesso', 'Sucesso', this.$toastConfig.success);
                            this.obterPropostaPreco(comLoading);
                        }
                    } else {
                        this.erros = response.errors || ['Erro ao salvar a proposta de preço'];
                        this.$toast.error(
                            'Erro ao salvar a proposta de preço!',
                            'Erro',
                            this.$toastConfig.error
                        );
                    }
                })
                .catch(error => {
                    console.error('Erro ao salvar a proposta de preço:', error);
                    this.erros = [`Erro ao salvar a proposta de preço: ${error}`];
                    this.$toast.error(
                        'Erro ao salvar a proposta de preço!',
                        'Erro',
                        this.$toastConfig.error
                    );
                })
                .finally(() => {
                    if (comLoading) this.$store.dispatch('removeRequest')
                });
        },

        verificarItensZerados(itens, itensInvalidos = []) {
            itens.forEach(item => {
                if (item.tipo && (!item.valorUnitario || item.valorUnitario <= 0)) {
                    itensInvalidos.push(`${item.item} - ${item.descricao}`);
                }

                if (item.itens && Array.isArray(item.itens) && item.itens.length > 0) {
                    this.verificarItensZerados(item.itens, itensInvalidos);
                }
            });

            return itensInvalidos;
        },

        recalcularValoresComBDI(itens) {
            const TIPO_MATERIAL = 2

            itens.forEach(item => {
                if (item.itens && item.itens.length > 0) {
                    this.recalcularValoresComBDI(item.itens)
                } else if (item.tipo) {
                    const valorUnitario = Number(item.valorUnitario) || 0

                    if (this.ehContratoDeEngenharia) {
                        const bdi = item.tipo == TIPO_MATERIAL
                            ? Number(this.propostaPreco.bdiDiferenciado)
                            : Number(this.propostaPreco.bdiGeral)
                        item.valorUnitarioComBDI = valorUnitario * (1 + bdi / 100)
                    } else {
                        item.valorUnitarioComBDI = valorUnitario
                    }

                    item.total = parseFloat((item.valorUnitarioComBDI * (Number(item.quantidade) || 0)).toFixed(2))
                }
            })
        },

        recalcularTudo() {
            const totalGeral = this.recalcularTotais(this.propostaPreco.itens)

            this.$set(this.propostaPreco, 'total', totalGeral)
            this.recalcularPesos(this.propostaPreco.itens, totalGeral)
        },

        recalcularTotais(itens) {
            let totalGrupo = 0

            itens.forEach(item => {
                if (item.itens && item.itens.length > 0) {
                    item.total = this.recalcularTotais(item.itens)
                }
                totalGrupo += Number(item.total) || 0
            })

            return totalGrupo
        },

        recalcularPesos(itens, totalGeral) {
            itens.forEach(item => {
                item.peso = totalGeral > 0
                    ? parseFloat(((item.total / totalGeral) * 100).toFixed(2))
                    : 0

                if (item.itens && item.itens.length > 0) {
                    this.recalcularPesos(item.itens, totalGeral)
                }
            })
        },

        pararAutoSalvar() {
            if (this.timerAutoSalvar) {
                clearTimeout(this.timerAutoSalvar)
                this.timerAutoSalvar = null
            }
        },

        agendarAutoSalvar() {
            this.pararAutoSalvar()

            const SEGUNDOS_AGUARDAR = 90;

            this.timerAutoSalvar = setTimeout(() => {
                this.timerAutoSalvar = null
                this.salvarPropostaPrecoAutomaticamente()
            }, SEGUNDOS_AGUARDAR * 1000)
        },

        salvarPropostaPrecoAutomaticamente() {
            this.$v.$touch()

            if (this.$v.$invalid){
                this.$toast.warning(
                    'Verifique os campos obrigatórios antes de salvar a proposta de preço.',
                    'Atenção',
                    this.$toastConfig.warning
                );

                return;
            }

            this.recalcularTudo();
            this.salvarPropostaPreco(false);
        },

        atualizarDataBaseParaReajustamento() {
            this.mostrarModalAtualizarDataBaseReajustamento = true;
        },

        async imprimirPropostaPreco() {
            const area = this.$refs.areaImpressao;

            if (!area) {
                console.error("Elemento não encontrado!");
                this.$toast.error(
                    'Erro ao gerar o PDF da proposta de preço!',
                    'Erro',
                    this.$toastConfig.error
                );
                return;
            }

            const agora = new Date();
            this.dataHoraImpressao = agora.toLocaleDateString('pt-BR') + ' às ' + agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
            this.nomeUsuarioImpressao = this.$store.getters.usuario.nome;

            await this.$nextTick();

            try {
                this.$store.dispatch('addRequest')

                await html2pdf()
                        .from(area)
                        .set({
                            margin: 3,
                            filename: 'proposta-preco.pdf',
                            html2canvas: {
                                scale: 2,
                                ignoreElements: (el) => el.classList.contains('nao-imprimir'),
                                onclone: (clonedDoc, element) => {
                                    element.querySelectorAll('.so-imprimir').forEach(el => {
                                        el.style.display = 'block';
                                    });
                                }
                            },
                            jsPDF: {
                                unit: 'mm',
                                format: 'a4',
                                orientation: 'portrait'
                            },
                            pagebreak: {
                                mode: ['avoid-all', 'css', 'legacy'],
                                before: '.pagebreak-before',
                                after: '.pagebreak-after',
                                avoid: ['.no-break', 'tr', 'td']
                            }
                        })
                        .save();

            } catch (error) {
                console.error("Erro ao gerar o PDF:", error);
                this.$toast.error(
                    'Erro ao gerar o PDF da proposta de preço!',
                    'Erro',
                    this.$toastConfig.error
                );
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },

        exportar() {
            this.$store.dispatch('addRequest')

            PropostaPrecoServico.Exportar(this.$route.params.propostaPrecoId)
                .then(response => {
                    if (response.status === 200) {
                        let nomeArquivo = 'OrcamentoSintetico.xlsx'
                        const contentDisposition = response.headers['content-disposition']

                        if (contentDisposition) {
                            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)

                            if (filenameMatch && filenameMatch[1])
                                nomeArquivo = decodeURIComponent(filenameMatch[1])
                        }

                        this.$download(response.data, nomeArquivo)

                        this.$toast.success('Proposta de preço exportada com sucesso', 'Sucesso', this.$toastConfig.success);

                    } else {
                        this.$toast.error(
                            'Erro ao exportar proposta de preço!',
                            'Erro',
                            this.$toastConfig.error
                        );
                    }
                })
                .catch(error => {
                    console.error('Erro ao exportar proposta de preço:', error);
                    this.erros = [`Erro ao exportar proposta de preço: ${error}`];
                    this.$toast.error(
                        'Erro ao exportar proposta de preço!',
                        'Erro',
                        this.$toastConfig.error
                    );
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                });
        },

        confirmarFinalizarPropostaPreco() {
            this.$v.$touch();

            if (this.$v.propostaPreco.$invalid) {
                this.$swal({
                    title: 'Atenção',
                    html: 'Verifique os valores de BDI antes de finalizar.',
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                });

                return;
            }

            const itensInvalidos = this.verificarItensZerados(this.propostaPreco.itens);

            if (itensInvalidos.length > 0) {
                this.$swal({
                    title: 'Atenção',
                    html: 'Existem campos de valor unitário não preenchidos ou zerados. Por favor, preencha todos os campos obrigatórios antes de finalizar.',
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                });

                return;
            }

            this.$swal({
                title: 'Confirmação',
                html: `Deseja confirmar a finalização da proposta de preço?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.pararAutoSalvar();
                    this.salvarPropostaPreco(true, () => this.finalizarPropostaPreco());
                }
            })
        },

        finalizarPropostaPreco() {
            this.pararAutoSalvar();
            this.$store.dispatch('addRequest')

            PropostaPrecoServico.Finalizar(this.$route.params.propostaPrecoId)
                .then(response => {
                    console.log(response);

                    if (response.data.success) {
                        this.erros = [];
                        this.$toast.success('Proposta de preço finalizada com sucesso', 'Sucesso', this.$toastConfig.success);
                        this.obterPropostaPreco();
                    } else {
                        this.erros = response.errors || ['Erro ao finalizar a proposta de preço'];
                        this.$toast.error(
                            'Erro ao finalizar a proposta de preço!',
                            'Erro',
                            this.$toastConfig.error
                        );
                    }
                })
                .catch(error => {
                    console.error('Erro ao finalizar a proposta de preço:', error);
                    this.erros = [`Erro ao finalizar a proposta de preço: ${error}`];
                    this.$toast.error(
                        'Erro ao finalizar a proposta de preço!',
                        'Erro',
                        this.$toastConfig.error
                    );
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                });
        },
    },

    mounted() {
        this.obterPropostaPreco();
    },

    beforeDestroy() {
        this.pararAutoSalvar()
    },
};

</script>

<style scoped>
.btn-solicitar-diligencia {
    background-color: rgba(255, 81, 0, 0.75) !important;
    border: 1px solid transparent !important;
    background-image: none !important;
    box-shadow: none !important;
    color: #fff !important;
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out;
}

.btn-solicitar-diligencia:hover,
.btn-solicitar-diligencia:focus,
.btn-solicitar-diligencia:active {
    background-color: #ff5100 !important;
    border: 1px solid rgba(255, 81, 0, 0.75) !important;
    color: #fff !important;
}

.so-imprimir {
    display: none;
}

.cabecalho-impressao,
.rodape-impressao {
    font-family: Arial, sans-serif;
}
</style>
